import { tinymcePasteIdentifierTag } from '../constants/paste';
import { googleDocImportIdentifierTag } from '../constants/googleDocs';
import convertGoogleToHTML, { convertGoogleDocToHTML
//@ts-expect-error untyped module
} from './convertGoogleToHTML';
//@ts-expect-error untyped module
import convertMSWordToHTML from './convertMSWordToHTML';
import convertEvernoteToHTML from './convertEvernoteToHTML';
import { compose } from '../utils/iterables';
import { getGenericPasteProcessingConverter } from './genericPasteProcessingConverter';
import { processEntities } from './processEntities';
import { figmaPasteProcessTransform } from './figmaPasteProcessTransform';
const DOCS_IMPORT_TEST = googleDocImportIdentifierTag;
const DOCS_TEST = new RegExp(`id="docs-internal-guid`);
const WORD_TEST = /<meta name=ProgId content=Word\.Document>/;
const EVERNOTE_TEST = /style=("|')-.[a-z]-clipboard:true;"/i;
const TINYMCE_TEST = tinymcePasteIdentifierTag;
export const converterNames = {
  CONVERT_GOOGLE_IMPORT_TO_HTML: 'googleImport',
  CONVERT_GOOGLE_TO_HTML: 'google',
  CONVERT_MSWORD_TO_HTML: 'msword',
  CONVERT_EVERNOTE_TO_HTML: 'evernote',
  TINYMCE: 'tinymce',
  UNKNOWN: 'unknown'
};
const pasteSourceMap = [{
  test: DOCS_IMPORT_TEST,
  converter: convertGoogleDocToHTML,
  converterName: converterNames.CONVERT_GOOGLE_IMPORT_TO_HTML
}, {
  test: DOCS_TEST,
  converter: convertGoogleToHTML,
  converterName: converterNames.CONVERT_GOOGLE_TO_HTML
}, {
  test: WORD_TEST,
  converter: convertMSWordToHTML,
  converterName: converterNames.CONVERT_MSWORD_TO_HTML
}, {
  test: EVERNOTE_TEST,
  converter: convertEvernoteToHTML,
  converterName: converterNames.CONVERT_EVERNOTE_TO_HTML
}, {
  test: TINYMCE_TEST,
  converter: x => x,
  converterName: converterNames.TINYMCE
}];
export const getBaseConverterForHTML = html => {
  return pasteSourceMap.find(pasteSource => html.match(pasteSource.test)) || {
    converter: x => x,
    converterName: converterNames.UNKNOWN
  };
};
export const getPastePreProcessWithConfig = ({
  formatTransformMap,
  clearAllStyles,
  defaultStylesMap,
  defaultAttributesMap
} = {}) => (html = '') => {
  const {
    converter,
    converterName
  } = getBaseConverterForHTML(html);

  // Add as many converters that take in one {html} arg as wanted
  const composedConverter = compose(processEntities, getGenericPasteProcessingConverter(formatTransformMap, clearAllStyles || converterName === converterNames.UNKNOWN, defaultStylesMap, defaultAttributesMap), figmaPasteProcessTransform, converter);
  return {
    converter: composedConverter,
    converterName
  };
};